export default {
  data() {
    return {};
  },

  created() {},

  methods: {
    storageUrl(path) {
      return this.$store.state.STORAGE_URL + path;
    },

    koboToNaira(kobo) {
      return (kobo / 100).toFixed(2);
    },

    nairatoKobo(naira) {
      return naira * 100;
    }
  }
};
